import { cn } from "@/lib/utils";
import { CircleAlert, CircleCheck } from "lucide-react";

interface AsyncOperationItemProps {
  label: string;
  description?: string;
  success?: boolean;
}

export const AsyncOperationItem = ({
  label,
  description,
  success,
}: AsyncOperationItemProps) => {
  const isSuccess = success ?? false;
  return (
    <div
      className={cn(
        "p-2 rounded text-sm",
        isSuccess ? "bg-green-50 text-green-900" : "bg-red-50 text-red-900",
      )}
    >
      <p className="font-medium flex items-center">
        {isSuccess ? (
          <CircleCheck className="w-4 h-4 mr-2 inline" />
        ) : (
          <CircleAlert className="w-4 h-4 mr-2 inline" />
        )}
        {label}
      </p>
      {description && <p className="text-xs mt-1 ml-6">{description}</p>}
    </div>
  );
};
